<template>

    <Toast/>

    <MenuSiCompact/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a @click="processHome" class="cursor-pointer"><i class="pi pi-home text-text-900"></i></a>
            </li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Help</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Glossary</a></li>
        </ul>

        <div style="height: 8px;"></div>

        <div class="grid">
            <div class="col-12">
                <span>
                    Definitions of common investing terms.
                </span>
            </div>
        </div>

        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 20px;"></div>

                    <DataTable
                        :value="glossaryDefinitions"
                        :scrollable="true" scrollHeight="1000px" scrollDirection="both"
                        :striped-rows="true"
                        :reorderableColumns="true"
                        :rowHover="true"
                        :sortMode="'multiple'"
                        dataKey="name"
                        class="p-datatable-gridlines">

                        <template #empty>
                            No glossary definitions found.
                        </template>

                        <Column field="number" header="Number" :sortable="true"
                                style="max-width: 200px; min-width: 200px"
                                frozen>
                            <template #body="{data}">
                                {{ data.id }}
                            </template>
                        </Column>

                        <Column field="name" header="Column Name" :sortable="true"
                                style="max-width: 200px; min-width: 200px"
                                frozen>
                            <template #body="{data}">
                                {{ data.name }}
                            </template>
                        </Column>

                        <Column field="definition" header="Column Definition" :sortable="true"
                                style="max-width: 600px; min-width: 600px">
                            <template #body="{data}">
                                <span v-html="data.definition"></span>
                            </template>
                        </Column>

                    </DataTable>

                </div>
            </div>
        </div>

    </div>

    <SiFooter/>

</template>

<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import CompanyService from "@/service/CompanyService";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import MenuSiCompact from "@/components/simodule/MenuSiCompact.vue";

export default {
    components: {
        MenuSiCompact,
        SiFooter,
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        document.title = "Simply Investing"; // Update the browser tab title
        this.setFavicon("images/blocks/logos/favicon.simplyinvesting.96x96.png");

        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[PhoneCalls][mounted] Data = ", userData);
            console.log("[PhoneCalls][mounted] this.profile = ", this.profile);
        } catch (e) {
            console.error("[PhoneCalls][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            console.log("[PhoneCalls][mounted] userConfigData.data = ", userConfigData.data);
        } catch (e) {
            console.error("[PhoneCalls][mounted] Could not find user config for user = ", this.userStore.user.id);

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }

        try {
            const [companyConfigData] = await Promise.all([
                CompanyService.getCompanyConfiguration(this.profile.companyId)
            ]);

            this.companyConfiguration = companyConfigData.data;
            console.log("[PhoneCalls][mounted] companyConfigData.data = ", companyConfigData.data);

        } catch (e) {
            console.error("[PhoneCalls][mounted] Error fetching additional data = ", e);

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }

        console.log("[PhoneCalls][mounted] this.userConfiguration = ", this.userConfiguration);
        console.log("[PhoneCalls][mounted] this.companyConfiguration = ", this.companyConfiguration);
    },
    data() {

        return {
            profile: {},
            companyConfiguration: {},
            regionTypes: [
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'Canada', code: 'CA'},
                {name: 'United States', code: 'US'},
                {name: 'India', code: 'IN'}
            ],
            accountTypes: [
                {name: 'Healthcare Practitioner', code: 'H'},
                {name: 'Financial Advisor', code: 'F'},
                {name: 'Small Business', code: 'S'}
            ],
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            glossaryDefinitions: [
                {
                    id: '1',
                    name: 'Balance Sheet',
                    definition: 'A balance sheet, reports on a company\'s assets, liabilities, and ownership equity at a given point in time.'
                },
                {
                    id: '2',
                    name: 'Book Value',
                    definition: 'Book value is the total value of the company\'s assets if a company were liquidated. In the United Kingdom, the term “net asset value” refers to the book value of a company.'
                },
                {
                    id: '3',
                    name: 'Capital Gain',
                    definition: 'Capital gain is a profit which results from selling a stock at a price higher than what was paid for it. For example if a stock was purchased for $12 then sold for $21 the capital gain would be $9 ($21-$12).'
                },
                {
                    id: '4',
                    name: 'Cash Flow Statement',
                    definition: 'A Cash flow statement reports on a company\'s cash flow activities, particularly its operating, financing and investing activities.'
                },
                {
                    id: '5',
                    name: 'Dividend',
                    definition: 'A dividend is a payment made by a corporation to its shareholder. It is the portion of corporate profits paid out to shareholders.'
                },
                {
                    id: '6',
                    name: 'Dividend Yield',
                    definition: 'The dividend yield indicates the return on an investment not including any capital gains. The dividend yield can be calculated by the following formula:\n' +
                        '<br/><br/>' +
                        '            Dividend Yield = (Annual Dividend) / (Share Price)'
                },
                {
                    id: '7',
                    name: 'Earnings',
                    definition: 'A company\'s earnings are its profits. A company generates revenue by selling a product or service, subtract all the costs to produce that product or service and the amount remaining is earnings. Earnings typically refer to after-tax net income, sometimes also known as the bottom line.'
                },
                {
                    id: '8',
                    name: 'Earnings Per Share',
                    definition: 'Earnings per share (EPS) are the total earnings for the year divided by the total number of outstanding shares.'
                },
                {
                    id: '9',
                    name: 'Shareholder Equity',
                    definition: 'Shareholder equity is the difference between a company’s assets and liabilities.'
                },
                {
                    id: '10',
                    name: 'Exchange Traded Fund (ETF)',
                    definition: 'An ETF may track an index, a commodity or a basket of assets like an index fund, but it trades like a stock on a stock exchange.'
                },
                {
                    id: '11',
                    name: 'Income Statement',
                    definition: 'An income statement is one of the financial statements of a company and it shows the company\'s revenues and expenses during a particular period. In the United Kingdom, the term “profit and loss account” refers to the income statement.'
                },
                {
                    id: '12',
                    name: 'Index Fund',
                    definition: 'An index fund is a type of mutual fund that is designed to match the components of a specific market index.'
                },
                {
                    id: '13',
                    name: 'Limit Order',
                    definition: 'A limit order is an order to buy a stock at no more than a specific price, or to sell a stock at no less than a specific price.'
                },
                {
                    id: '14',
                    name: 'Long-term Debt',
                    definition: 'Loans and financial obligations lasting over one year or more. In the United Kingdom long-term debt is known as "long-term loan."'
                },
                {
                    id: '15',
                    name: 'Market Capitalization',
                    definition: 'Market capitalization (or market cap) is the total value of the issued shares of a publicly traded company; it’s equal to the share price times the number of shares outstanding.'
                },
                {
                    id: '16',
                    name: 'Market Order',
                    definition: 'A market order is a buy or sell order to be executed immediately at current market prices.'
                },
                {
                    id: '17',
                    name: 'MER',
                    definition: 'Management Expense Ratoo (MER) is a fee charged by mutual funds to cover their expenses for operating the mutual fund.'
                },
                {
                    id: '18',
                    name: 'Mutual Funds',
                    definition: 'A mutual fund pools money from many investors, and then invests that money in stocks, bonds, or both.'
                },
                {
                    id: '19',
                    name: 'NYSE Composite',
                    definition: 'NYSE Composite is a stock market index covering all common stock listed on the New York Stock Exchange.'
                },
                {
                    id: '20',
                    name: 'Overvalued',
                    definition: 'A stock is considered overvalued (priced high) when it\'s current dividend yield is less than or equal to it\'s average dividend yield. For non-dividend stocks if it\'s current P/E Ratio is greater than or equal to it\'s average P/E Ratio then the stock is considered overvalued.'
                },
                {
                    id: '21',
                    name: 'Payout Ratio',
                    definition: 'Payout Ratio is the amount of earnings paid out in dividends to shareholders. The Payout Ratio formula is shown below:\n' +
                        '<br/><br/>' +
                        '            Payout Ratio = (Dividends per Share) / (Earnings per Share)'
                },
                {
                    id: '22',
                    name: 'P/B Ratio',
                    definition: 'The Price-to-Book Raito is a ratio used to compare a stock\'s market value to its book value per share.The P/B Ratio formula is shown below:\n' +
                        '<br/><br/>' +
                        '        P/B Ratio = (Share Price) / (Book Value per Share)'
                },
                {
                    id: '23',
                    name: 'P/E Ratio',
                    definition: 'The Price-to-Earnings Ratio is a ratio used to compare a stock\'s market value to its earnings per share.The P/E Ratio formula is shown below:\n' +
                        '<br/><br/>' +
                        '        P/E Ratio = (Share Price) / (Earnings per Share)'
                },
                {
                    id: '24',
                    name: 'Revenue',
                    definition: 'Revenue is the amount of money that a company generates by selling a product or service.'
                },
                {
                    id: '25',
                    name: 'Share Buyback',
                    definition: 'The repurchase of outstanding shares by a company in order to reduce the number of their shares on the market.'
                },
                {
                    id: '26',
                    name: 'Short-term Debt',
                    definition: 'Loans and financial obligations due within a year.'
                },
                {
                    id: '27',
                    name: 'Stock or Share',
                    definition: 'A stock or share represents a piece of a company. A shareholder or stockholder is part owner of the company.'
                },
                {
                    id: '28',
                    name: 'Stock Market',
                    definition: 'The stock market is a place where stocks (shares) are bought and sold.'
                },
                {
                    id: '29',
                    name: 'Stock Ticker Symbol',
                    definition: 'A stock symbol or ticker symbol is an abbreviation used to uniquely identify shares of a publicly traded company on a particular stock market.'
                },
                {
                    id: '30',
                    name: 'Stop Order',
                    definition: 'A stop order also referred to as a stop-loss order, is an order to buy or sell a stock once the price of the stock reaches a specified price, known as the stop price. When the stop price is reached, a stop order becomes a\n' +
                        '        market order.'
                },
                {
                    id: '31',
                    name: 'Undervalued',
                    definition: 'A stock is considered undervalued (priced low) when it\'s current dividend yield is higher than it\'s average dividend yield. For non-dividend stocks if it\'s current P/E Ratio is less than it\'s average P/E Ratio then the stock is considered undervalued.'
                }
            ]
        }
    },
    methods: {
        callOverview() {
            this.$router.push("siOverview");
        },
        setFavicon(url) {
            // Check if a <link rel="icon"> tag already exists
            let faviconLink = document.querySelector("link[rel='icon']");

            if (!faviconLink) {
                // Create a new <link> element if one doesn't exist
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }

            // Update the favicon URL
            faviconLink.href = url;
        },
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        processHome() {
            console.log("[MenuConfiguration][processHome] Beginning.");
            this.closeAllMenus();
            this.safeNavigate('/siHome');
        },
        async updateConfiguration() {

            var updatedConfiguration = {
                region: this.companyConfiguration.region,
                type: this.companyConfiguration.type,
                practitionerType: this.companyConfiguration.practitionerType,
                requirePhone: this.companyConfiguration.requirePhone,
                requireWebsite: this.companyConfiguration.requireWebsite,
                website: this.companyConfiguration.website,
                qualification: this.companyConfiguration.qualification,
                registrationNumber: this.companyConfiguration.registrationNumber,
                practiceNumber: this.companyConfiguration.practiceNumber,
                enableRemindersEmail: this.companyConfiguration.enableRemindersEmail,
                enableRemindersSms: this.companyConfiguration.enableRemindersSms,
                enableRemindersWhatsapp: this.companyConfiguration.enableRemindersWhatsapp,
                enableRemindersPhone: this.companyConfiguration.enableRemindersPhone
            };

            console.log("[" + name + "][processUpdateConfiguration] Updated configuration. Data = ", updatedConfiguration);

            this.activeTab = 2;

            try {
                // Delete the appointment
                const response = await CompanyService.updateCompanyConfiguration(this.profile.companyId, updatedConfiguration);
                console.log('[PhoneCalls][deletePhoneCall] Response = ', response);

                const [companyConfigData] = await Promise.all([
                    CompanyService.getCompanyConfiguration(this.profile.companyId)
                ]);

                this.companyConfiguration = companyConfigData.data;
                this.userStore.setCompanyConfiguration(companyConfigData.data);
                console.log("[PhoneCalls][mounted] companyConfigData.data = ", companyConfigData.data);

                if (this.companyConfiguration.manualClientIntakeForms == null) {
                    this.companyConfiguration.manualClientIntakeForms = 'Y';
                }

                if (this.companyConfiguration.manualBillingInstructions == null) {
                    this.companyConfiguration.manualBillingInstructions = 'Y';
                }

                if (this.companyConfiguration.weeklyNewClients == null) {
                    this.companyConfiguration.weeklyNewClients = 1;
                }

                if (this.companyConfiguration.weeklyWorkingDays == null) {
                    this.companyConfiguration.weeklyWorkingDays = 4;
                }

                if (this.companyConfiguration.weeklyBillableAppointments == null) {
                    this.companyConfiguration.weeklyBillableAppointments = 3;
                }

                if (this.companyConfiguration.clientSplit == null) {
                    this.companyConfiguration.clientSplit = 80;
                }

                if (this.companyConfiguration.monthlyBankStatements == null) {
                    this.companyConfiguration.monthlyBankStatements = 1;
                }

                if (this.companyConfiguration.bankStatementSize == null) {
                    this.companyConfiguration.bankStatementSize = 3;
                }

                if (this.companyConfiguration.monthlyRemittances == null) {
                    this.companyConfiguration.monthlyRemittances = 4;
                }

                if (this.companyConfiguration.remittanceSize == null) {
                    this.companyConfiguration.remittanceSize = 2;
                }

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Configuration updated',
                    life: 3000
                });

            } catch (e) {
                console.error('[PhoneCalls][deletePhoneCall] Error:', e);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update configuration. Please try again.',
                    life: 3000
                });

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
